// NIS2 Classification Data
export const NIS2_DATA = {
  thresholds: {
    micro: { max_employees: 10, max_turnover: 2000000, max_balance_sheet: 2000000 },
    small: { max_employees: 50, max_turnover: 10000000, max_balance_sheet: 10000000 },
    medium: { max_employees: 250, max_turnover: 50000000, max_balance_sheet: 43000000 }
  },
  sectors: {
    essential: [
      "Digitální infrastruktura a služby",
      "Drážní doprava",
      "Energetika - Elektřina",
      "Energetika - Ropa a ropné produkty",
      "Energetika - Teplárenství",
      "Energetika - Vodík",
      "Energetika - Zemní plyn",
      "Finanční trh",
      "Letecká doprava",
      "Obranný průmysl",
      "Silniční doprava",
      "Veřejná správa a výkon veřejné moci",
      "Vesmírný průmysl",
      "Vodní doprava",
      "Vodní hospodářství",
      "Zdravotnictví"
    ],
    important: [
      "Chemický průmysl",
      "Odpadové hospodářství",
      "Poštovní a kurýrní služby",
      "Potravinářský průmysl",
      "Věda, výzkum a vzdělávání",
      "Výrobní průmysl"
    ]
  },
  sectorsData: [
    {
      sector: "Digitální infrastruktura a služby",
      category: "essential",
      services: [
        "Poskytování platformy sociální sítě",
        "Poskytování řízené bezpečnostní služby",
        "Poskytování řízené služby",
        "Poskytování služby cloud computingu",
        "Poskytování služby datového centra",
        "Poskytování služby internetového vyhledávače",
        "Poskytování služby on-line tržiště",
        "Poskytování služby registrace a správy doménových jmen",
        "Poskytování služby sítě pro doručování obsahu",
        "Poskytování služby systému překladu doménových jmen",
        "Poskytování služby výměnného uzlu internetu",
        "Poskytování služby vytvářející důvěru",
        "Poskytování veřejně dostupné služby elektronických komunikací",
        "Provozování Národního CERT",
        "Správa a provoz domény gov.cz",
        "Správa a provoz registru domény nejvyšší úrovně",
        "Správa kvalifikovaného systému elektronické identifikace",
        "Zajišťování veřejné komunikační sítě"
      ]
    },
    {
      sector: "Drážní doprava",
      category: "essential",
      services: [
        "Provoz celostátní dráhy",
        "Provoz drážní dopravy na celostátní dráze",
        "Provoz drážní dopravy na regionální dráze",
        "Provoz drážní dopravy na veřejně přístupné vlečce",
        "Provoz regionální dráhy",
        "Provoz veřejně přístupné vlečky",
        "Provoz zařízení služeb",
        "Provozování železniční dopravní cesty"
      ]
    },
    {
      sector: "Energetika - Elektřina",
      category: "essential",
      services: [
        "Agregace elektřiny podle energetického zákona",
        "Činnost Elektroenergetického datového centra",
        "Činnost nominovaného organizátora trhu s elektřinou",
        "Obchod s elektřinou",
        "Poskytování flexibility podle energetického zákona",
        "Provoz distribuční soustavy elektřiny",
        "Provoz přenosové soustavy elektřiny",
        "Provoz veřejně přístupné dobíjecí stanice",
        "Ukládání elektřiny",
        "Výroba elektřiny"
      ]
    },
    {
      sector: "Energetika - Ropa a ropné produkty",
      category: "essential",
      services: [
        "Provoz produktovodu",
        "Provoz ropovodu",
        "Provoz skladovacího zařízení pro skladování ropy",
        "Provoz veřejné čerpací stanice motorového benzínu nebo motorové nafty",
        "Těžba ropy",
        "Výkon činnosti ústředního správce zásob",
        "Zpracovávání ropy"
      ]
    },
    {
      sector: "Energetika - Teplárenství",
      category: "essential",
      services: [
        "Provoz soustavy zásobování tepelnou energií",
        "Výroba tepelné energie"
      ]
    },
    {
      sector: "Energetika - Vodík",
      category: "essential",
      services: [
        "Přeprava vodíku",
        "Skladování vodíku",
        "Výroba vodíku"
      ]
    },
    {
      sector: "Energetika - Zemní plyn",
      category: "essential",
      services: [
        "Obchod se zemním plynem",
        "Provoz distribuční soustavy zemního plynu",
        "Provoz přepravní soustavy zemního plynu",
        "Uskladňování zemního plynu",
        "Výroba zemního plynu"
      ]
    },
    {
      sector: "Finanční trh",
      category: "essential",
      services: [
        "Činnost instituce elektronických peněz",
        "Činnost platební instituce",
        "Činnost ústřední protistrany",
        "Činnost úvěrové instituce",
        "Provoz obchodního systému"
      ]
    },
    {
      sector: "Letecká doprava",
      category: "essential",
      services: [
        "Letové navigační služby",
        "Provoz letecké dopravy",
        "Provoz mezinárodního letiště",
        "Provoz pomocných zařízení v rámci mezinárodního letiště"
      ]
    },
    {
      sector: "Obranný průmysl",
      category: "essential",
      services: [
        "Obchod s vojenským materiálem",
        "Výroba vojenského materiálu"
      ]
    },
    {
      sector: "Silniční doprava",
      category: "essential",
      services: [
        "Činnost subjektu odpovědného za kontrolu řízení provozu",
        "Provoz inteligentního dopravního systému"
      ]
    },
    {
      sector: "Veřejná správa a výkon veřejné moci",
      category: "essential",
      services: [
        "Výkon svěřených pravomocí"
      ]
    },
    {
      sector: "Vesmírný průmysl",
      category: "essential",
      services: [
        "Zajištění podpory poskytování služeb využívajících kosmického prostoru"
      ]
    },
    {
      sector: "Vodní doprava",
      category: "essential",
      services: [
        "Činnost námořní vodní dopravy",
        "Provoz řídícího orgánu přístavu",
        "Provoz služby lodní dopravě (VTS)",
        "Provoz vodního díla nebo zařízení v rámci přístavu"
      ]
    },
    {
      sector: "Vodní hospodářství",
      category: "essential",
      services: [
        "Provozování kanalizace sloužící veřejné potřebě",
        "Provozování vodovodu sloužícího veřejné potřebě"
      ]
    },
    {
      sector: "Zdravotnictví",
      category: "essential",
      services: [
        "Činnost referenční laboratoře EU zahrnuté do sítě referenčních laboratoří pro oblast veřejného zdraví",
        "Poskytování zdravotní péče",
        "Poskytování zdravotnické záchranné služby",
        "Výroba diagnostických zdravotnických prostředků in vitro",
        "Výroba léčivých látek",
        "Výroba léčivých přípravků pro humánní použití s výjimkou výrobních operací v rozsahu certifikace šarží, sekundárního balení, chemické/fyzikální kontroly jakosti a dovozu léčivých přípravků",
        "Výroba zdravotnických prostředků",
        "Výroba zdravotnických prostředků považovaných za kriticky důležité v případě mimořádné situace v oblasti veřejného zdraví",
        "Výzkum a vývoj léčivých přípravků"
      ]
    },
    {
      sector: "Chemický průmysl",
      category: "important",
      services: [
        "Uvádění chemických látek podléhajících registraci na trh",
        "Užívání objektu za účelem umístění nebezpečné látky",
        "Výroba chemických látek podléhajících registraci",
        "Výroba předmětů podléhajících registraci nebo oznámení"
      ]
    },
    {
      sector: "Odpadové hospodářství",
      category: "important",
      services: [
        "Obchodování s odpadem",
        "Provoz zařízení určeného pro nakládání s odpady",
        "Přeprava odpadu",
        "Zprostředkování nakládání s odpadem"
      ]
    },
    {
      sector: "Poštovní a kurýrní služby",
      category: "important",
      services: [
        "Poskytování kurýrní služby",
        "Poskytování poštovní služby"
      ]
    },
    {
      sector: "Potravinářský průmysl",
      category: "important",
      services: [
        "Průmyslová výroba potravin",
        "Průmyslové zpracování potravin",
        "Velkoobchodní distribuce potravin"
      ]
    },
    {
      sector: "Věda, výzkum a vzdělávání",
      category: "important",
      services: [
        "Výzkum a vývoj"
      ]
    },
    {
      sector: "Výrobní průmysl",
      category: "important",
      services: [
        "Výroba elektrických zařízení (oddíl 27 CZ-NACE)",
        "Výroba motorových vozidel (kromě motocyklů), přívěsů a návěsů (oddíl 29 CZ-NACE)",
        "Výroba ostatních dopravních prostředků a zařízení (oddíl 30 CZ-NACE)",
        "Výroba počítačů, elektronických a optických přístrojů a zařízení (oddíl 26 CZ-NACE)",
        "Výroba strojů a zařízení jinde nezařazených (oddíl 28 CZ-NACE)"
      ]
    }
  ]
};

export const SPECIAL_SERVICES = {
  annex_ii_digital: [
    "Poskytování platformy sociální sítě",
    "Poskytování služby internetového vyhledávače",
    "Poskytování služby on-line tržiště"
  ],
  always_essential: [
    "Poskytování služby vytvářející důvěru",
    "Poskytování služby registrace a správy doménových jmen",
    "Správa a provoz registru domény nejvyšší úrovně",
    "Správa a provoz domény gov.cz",
    "Provozování Národního CERT",
    "Správa kvalifikovaného systému elektronické identifikace"
  ],
  medium_as_essential: [
    "Poskytování veřejně dostupné služby elektronických komunikací",
    "Zajišťování veřejné komunikační sítě"
  ]
};
